module.exports = __webpack_public_path__ + "static/media/Operario.a0fd65cd.svg";